import { Injectable } from '@angular/core';
import { ReportsFilterObj } from '../../../interfaces/data-objects';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageSettingsService {

  filterObj: ReportsFilterObj = {
    start_date: '',
    end_date: '',
    transaction_types_list: [],
    functional_unit_list: [],
    managing_office_list: [],
    producer_list: [],
    all_functionals: false,
    all_managings: false,
    all_transactions: false,
    all_producers: false,
  };

  constructor() { }

  createLocalFilters(obj: ReportsFilterObj): void {
    const reportfilters = obj;
    window.localStorage.setItem('reportfilters', JSON.stringify(reportfilters));
  }

  getLocalFilters(): ReportsFilterObj {
    if (window.localStorage.getItem('reportfilters') === null) {
      this.createLocalFilters(this.filterObj);
      return JSON.parse(window.localStorage.getItem('reportfilters') ?? '');
    } else {
      return JSON.parse(window.localStorage.getItem('reportfilters') ?? '');
    }
  }

  updateLocalFilters(data: ReportsFilterObj): void {
    let filters = JSON.parse(window.localStorage.getItem('reportfilters') ?? '');
    filters = { ...filters, ...data };
    window.localStorage.setItem('reportfilters', JSON.stringify(filters));
  }

  resetLocalFilters(): void {
    this.createLocalFilters(this.filterObj);
  }

}
